import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl101ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    fudocDoyBranch: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    coDateStart: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .min(
        new Date(1753, 0, 1),
        t("Η ημερομηνία δεν μπορεί να είναι πριν από 01/01/1753"),
      )
      .required(t("Το πεδίο είναι υποχρεωτικό")),
    docPraktFileDate: yup
      .date()
      .nullable()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .min(
        new Date(1753, 0, 1),
        t("Η ημερομηνία δεν μπορεί να είναι πριν από 01/01/1753"),
      ),
    prefectureId: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    d02_code: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    coAddress: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    coAddressNumber: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    coZipCode: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .matches(/^\d{5}$/, t("Το πεδίο πρέπει να αποτελείται από 5 ψηφία")),
    addressCity: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    chamberResponsible: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    coPhone1: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .matches(
        /^(\+30)?(\d{10})$/,
        t("Το πεδίο πρέπει να αποτελείται από 10 ψηφία"),
      ),
    coEmail: yup
      .string()
      .email(t("Το πεδίο Email πρέπει να περιέχει έγκυρη διεύθυνση email"))
      .required(t("Το πεδίο είναι υποχρεωτικό")),
    primaryKad: yup
      .object()
      .shape({
        value: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
        label: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      })
      .required(t("Το πεδίο είναι υποχρεωτικό")),
  });
};
